jQuery( ( $ ) => {

	$( '.recycle' ).click( async function( event ) {
		event.preventDefault();
		const formData = new FormData();
		formData.append( 'action', 'delete_saved_card' );
		formData.append( 'token', $( this ).data( 'token' ) );
		const response = await $.ajax( {
			method: 'post',
			processData: false,
			contentType: false,
			cache: false,
			data: formData,
			enctype: 'multipart/form-data',
			url: red61.ajax_url,
		} ).promise();

		if ( response.success ) {
			$( this ).closest( 'li' ).remove();
			if ( 1 > $( 'li', $( this ).closest( 'ul' ) ).not( '.no-cards' ).length ) {
				$( 'li.no-cards' ).removeClass( 'd-none' );
			}
		}
	} );

	$( '.account-display input.checkbox-style' ).each( function() {
		if ( $( this ).is( ':checked' ) ) {
			$( this ).prop( 'disabled', true );
		}
		else {
			$( this ).closest( '.check_style' ).remove();
		}

	} );
	if( 0 === $( '.account-display input.checkbox-style:checked' ).length ) {

		if ( $( '.account-display' ).length ) {
			$( '.pref-message' ).removeClass( 'd-none' );
			$( '.question-group' ).remove();
		}

	}

	$( 'button[type="submit"]', '.form-account-update' ).on( 'click', function () {
		const form = $( this ).closest( '.form-account-update' );
		const alternativeAddressFields = $( '.alternative-address', form );
		const requiredAlternativeAddressFields = alternativeAddressFields.filter( '[data-required="1"]' );

		let alternativeAddressProvided = false;
		alternativeAddressFields.each( function () {
			if ( $( this ).val() ) {
				alternativeAddressProvided = true;
				return false;
			}
		} );

		if ( alternativeAddressProvided ) {
			requiredAlternativeAddressFields.attr( 'required', true );
		} else {
			requiredAlternativeAddressFields.attr( 'required', false );
		}
	} );

	$( function(){
		$( '#dateOfBirth' ).datepicker( { dateFormat: 'yyyy-mm-dd' } ).bind( 'change',function(){
			let minValue = $( this ).val();
			minValue = $.datepicker.parseDate( 'yyyy-mm-dd', minValue );
			minValue.setDate( minValue.getDate()+1 );
			$( '#to' ).datepicker( 'option', 'minDate', minValue );
		} );
	} );

	$( function(){
		$( '#dateOfBirthAccountPage' ).datepicker( { dateFormat: 'yyyy-mm-dd' } ).bind( 'change',function(){
			let minValue = $( this ).val();
			minValue = $.datepicker.parseDate( 'yyyy-mm-dd', minValue );
			minValue.setDate( minValue.getDate()+1 );
			$( '#to' ).datepicker( 'option', 'minDate', minValue );
		} );
	} );
	
} );
